import module from './module';
import {InviteController} from './controllers/InviteController';
import OrderSetupDialogController from './controllers/OrderSetupDialogController';
import OrderCheckoutController from './controllers/OrderCheckoutController';
import OrderCheckoutFullMixedController from './controllers/OrderCheckoutFullMixedController';
import OrderConfirmationController from './controllers/OrderConfirmationController';
import OrderPayController from './controllers/OrderPayController';
import OrderTabAddPeopleController from './controllers/OrderTabAddPeopleController';
import OrderTabBudgetController from './controllers/OrderTabBudgetController';
import OrderTabDeliveryAddressController from './controllers/OrderTabDeliveryAddressController';
import OrderTabFinishController from './controllers/OrderTabFinishController';
import OrderTabPayModeController from './controllers/OrderTabPayModeController';
import OrderTabPaymentDetailsController from './controllers/OrderTabPaymentDetailsController';
import OrderTabPreviewController from './controllers/OrderTabPreviewController';
import OrderTabDeliveryModeController from './controllers/OrderTabDeliveryModeController';
import OrderSummaryPageController from './controllers/OrderSummaryPageController';

import OrderAddPeopleDirective from './directives/OrderAddPeopleDirective';
import OrderContactViewDirective from './directives/OrderContactViewDirective';

import OrderDateService from './services/orderDateService';
import routes from './routeConfig';
import {OrderTabDeadlineController} from "./controllers/OrderTabDeadlineController";

module.factory('OrderDateService', ['ConfigurationService', (configurationService) => {
    return configurationService.getItem('storeHours').then((storeHours) => {
        return configurationService.getItem('deliveryDaysRange').then((deliveryDaysRange) => {
            return function (addMinutes, maximumDate) {
                return new OrderDateService(storeHours, deliveryDaysRange, addMinutes, maximumDate);
            };
        });
    });
}]);

module.config([
    '$stateProvider',
    function ($stateProvider) {
        routes.forEach(route => {
            $stateProvider
                .state(route);
        });
    }
]);

module.controller('OrderTabDeadline', OrderTabDeadlineController);
module.controller('Cartonomy.Order.OrderSummaryPageController', OrderSummaryPageController);

export default module.name;



// WEBPACK FOOTER //
// ./src/modules/order/index.js